import { ModalName } from "@/app/constants/modalRegistery";
import { useAppDispatch, useAppSelector } from "@/app/lib/features/redux/redux.hook";
import { useCallback } from "react";
import { CreateModalOptions } from "./modal.types";
import { append, destroy, destroyAll, destroyByName } from "./modal.slice";

/**
 * useModal'ın selector'süz kardeşi — SADECE modal açan bileşenler için.
 *
 * useModal() tüm `state.modal`'a abone olur: bir modal açılıp kapandığında onu
 * çağıran her bileşen yeniden render olur. Ana sayfada 84 ProductCard bunu
 * yapıyordu; tek bir "AI dene" dokunuşu tüm kart ağacını iki kez render
 * ettiriyordu. dispatch referansı sabit olduğu için bu hook'u kullanan bileşen
 * modal state'i değiştiğinde HİÇ render olmaz.
 *
 * `modals` listesini okuyan bileşenler (ModalProvider vb.) useModal kullanmaya
 * devam etmeli.
 */
export const useCreateModal = () => {
  const dispatch = useAppDispatch();

  return useCallback(
    (name: ModalName, data?: unknown, options?: CreateModalOptions) => {
      dispatch(
        append({
          name,
          data,
          title: options?.title,
          description: options?.description,
          size: options?.size,
        }),
      );
    },
    [dispatch],
  );
};

const useModal = () => {
  const dispatch = useAppDispatch();
  const { modals } = useAppSelector((state) => state.modal);

  const createModal = useCallback(
    (name: ModalName, data?: unknown, options?: CreateModalOptions) => {
      dispatch(
        append({
          name,
          data,
          title: options?.title,
          description: options?.description,
          size: options?.size,
        }),
      );
    },
    [dispatch],
  );

  const destroyModal = useCallback(() => {
    dispatch(destroy());
  }, [dispatch]);

  const destroyAllModal = useCallback(() => {
    dispatch(destroyAll());
  }, [dispatch]);

  const destroyModalByName = useCallback((name: string) => {
    dispatch(destroyByName(name));
  }, [dispatch]);

  return {
    modals,
    createModal,
    destroyModal,
    destroyAllModal,
    destroyModalByName,
  };
};

export default useModal;
